import React, { useEffect, useState } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './footer.css'
import '../../../assets/css/style.css'
import logoImg from '../../../assets/logos/logo.svg'
import { useNavigate, useLocation } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const onNavClick = (pathname) => {
    navigate(pathname);
  };
  const isActive = (path) => location.pathname === path;
  return (
    <>
      <footer>
        <div className="container">
          <div className="footer_outer">
            {/* Logo Section */}
            <div className="footer_box1">
              <div className="footer_logo">
                <img src={logoImg} alt="Logo" />
              </div>
            </div>

            {/* Social Links */}
            <div className="footer_box2">
              <h2>Social Links</h2>
              <div className="social_icons">
                <a
                  href="https://www.linkedin.com/company/techfeatures/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={require("../../../assets/icons/linkedin.png")} alt="LinkedIn" />
                </a>
                <a
                  href="https://wa.me/+918588889893"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={require("../../../assets/icons/whatsapp.png")} alt="WhatsApp" />
                </a>
              </div>
            </div>

            {/* Information Links */}
            <div className="footer_box3">
              <h2>Information</h2>
              <ul>
                <li onClick={() => onNavClick("/home")}>Home</li>
                <li onClick={() => onNavClick("/about")}>About us</li>
                <li onClick={() => onNavClick("/services")}>Services</li>
                <li onClick={() => onNavClick("/portfolio")}>Portfolio</li>
                {/* <li onClick={() => onNavClick("/hiredev")}>Hire Developer</li> */}
                <li onClick={() => onNavClick("/contact")}>Contact Us</li>
                {/* <li onClick={() => onNavClick("/blog")}>Blog</li> */}
              </ul>
            </div>

            {/* Reach Us Section */}
            <div className="footer_box4">
              <h2>Reach Us</h2>
              <div className="contact_info">
                <div className="contact_item">
                  <div className='footer_icons' >
                    <i class="bi bi-geo-alt"></i>
                  </div>
                  {/* <img src={require("../../../assets/icons/location.png")} alt="Location" /> */}
                  <p>Almora, Uttarakhand, India</p>
                </div>
                <div className="contact_item">
                  <div className='footer_icons'>
                    <i class="bi bi-envelope"></i>
                  </div>
                  {/* <img src={require("../../../assets/icons/email.png")} alt="Email" /> */}
                  <p>contact@techfeature.in</p>
                </div>
                <div className="contact_item">
                  <div className='footer_icons'>
                    <i class="bi bi-telephone"></i>
                  </div>
                  {/* <img src={require("../../../assets/icons/phone.png")} alt="Phone" /> */}
                  <p>+91-8588889893</p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom Line */}
          <div className="footer_bottom">
            <p>TECH FEATURES PVT LTD COPYRIGHT ©2025 ALL RIGHTS RESERVED</p>
          </div>
        </div>
      </footer>

    </>
  )
}
